export default {
    methods: {
        getUserChoiceValue(key, source = null) {
            const target = source || this.prestation
            const choices = target?.userChoices || target?.user_choices
            if (!choices) {
                return null
            }
            const choice = choices.find((c) => c.key === key)
            return choice ? choice.value : null
        },
        isChoiceEditable(key, source = null) {
            if (key === 'reservation_mode') return true
            const target = source || this.prestation
            const choices = target?.userChoices || target?.user_choices
            if (!choices) return true
            const choice = choices.find((c) => c.key === key)
            if (choice) {
                return choice.can_update == 1 || choice.can_update === true
            }
            return true
        },
    },
}
